module.exports = __webpack_public_path__ + "static/media/gamesPlayed.90b9438b.svg";